import { render, staticRenderFns } from "./VerificaNoteCard.vue?vue&type=template&id=0855a30e&"
import script from "./VerificaNoteCard.vue?vue&type=script&lang=js&"
export * from "./VerificaNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./VerificaNoteCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/VerificaNoteCard.vue
// module id = 158
// module chunks = 0